module.exports = __webpack_public_path__ + "img/expense.e08081ff.png";